module.exports = __webpack_public_path__ + "img/ic_mail_circle.aa8817b2.svg";